{
	"ariaOpenSelectionMode": "Open Selection Mode"
}
